import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map, Observable } from "rxjs";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { GetVirkeskopskontraktRouteParamsQuery } from "./virkeskopskontrakt-search-params.resolver";

@Component({
    selector: "rask-kontrakt-extern",
    imports: [RaskCommonModule],
    templateUrl: "./kontrakt-extern.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./kontrakt-extern.component.scss"
})
export class KontraktExternComponent {
    protected searchParams$: Observable<GetVirkeskopskontraktRouteParamsQuery>;
    private readonly activatedRoute = inject(ActivatedRoute);

    constructor() {
        this.searchParams$ = this.activatedRoute.data.pipe(
            map(d => d.searchParams)
        );
    }
}
